import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.deliveries')
  .factory('$deliveries', DeliveriesArray);

/* @ngInject */
function DeliveriesArray($bringozFactory: $bringozFactory,
                         DeliveriesAPI: BringozApi,
                         Deliveries_DS: DataStoreConfig,
                         Deliveries_PN: PushNotificationsConfig) {

  function $deliveries() {
    return $bringozFactory(null, DeliveriesAPI, Deliveries_DS, Deliveries_PN);
  }

  return $deliveries;
}
